export default "__VITE_ASSET__6492e617__"